/**
 * Device detection utilities for determining platform-specific behavior
 */

/**
 * Detects if the current device is running iOS (iPhone, iPad, iPod)
 * Includes special detection for iOS 13+ iPad which reports as desktop
 *
 * @returns True if running on iOS device, false otherwise
 */
export const isIOS =
  /(iPad|iPhone|iPod)/i.exec(window.navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

/**
 * Detects if the current device is running Android
 *
 * @returns True if running on Android device, false otherwise
 */
export const isAndroid = /Android/i.exec(window.navigator.userAgent);
